export const analyticsConfig = {
  enabled: false,
  endpoints: {
    stats: '/api/analytics/stats',
    track: '/api/analytics/track'
  },
  batchSize: 10,
  maxRetries: 3,
  flushIntervalMs: 5000,
  dashboardRefreshIntervalMs: 60000,
  staleAfterMs: 1000 * 60 * 60 * 24 * 2,
  requestCache: 'no-store' as RequestCache
} as const;
